export class RegularExpressions {
	private static urlBody =
		"(https?:\\/\\/)?(([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})(:\\d{1,5})?(\\/[a-zA-Z0-9._~%!$&'()*+,;=:@\\-]*)*(\\?[a-zA-Z0-9._~%!$&'()*+,;=:@\\/?\\-]*)?(\\#[a-zA-Z0-9._~%!$&'()*+,;=:@\\/?\\-]*)?"

	private static mailBody =
		"(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+(\\.[-!#$%&'*+0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+"

	public static url = `^${RegularExpressions.urlBody}$`

	public static mail = `^${RegularExpressions.mailBody}$`

	// Hyperlink for the rich-text editor: a mailto: address or a web URL.
	// Reuses the mail/url bodies so the accepted formats stay in sync.
	public static hyperlink = `^(mailto:${RegularExpressions.mailBody}|${RegularExpressions.urlBody})$`

	public static phone = "^[0-9+-]{1}[0-9-/()\\s]{2,}$";

	public static guid = "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$"

}
